import { createContext, useContext, useMemo } from "react";

export type PendingSessionContextValue = {
  pendingSessionId: string | null;
  onConfirm: () => void;
  onReject: () => void;
  isConfirming: boolean;
  isRejecting: boolean;
  /** Trigger a thread data refetch (e.g. after a per-node confirm/reject). */
  onRefetch: () => void;
};

const PendingSessionContext = createContext<PendingSessionContextValue | null>(
  null,
);

export function PendingSessionProvider({
  children,
  value,
}: {
  children: React.ReactNode;
  value: PendingSessionContextValue;
}) {
  const memoized = useMemo(
    () => value,
    [
      value.pendingSessionId,
      value.onConfirm,
      value.onReject,
      value.isConfirming,
      value.isRejecting,
      value.onRefetch,
    ],
  );
  return (
    <PendingSessionContext.Provider value={memoized}>
      {children}
    </PendingSessionContext.Provider>
  );
}

export function usePendingSession(): PendingSessionContextValue | null {
  return useContext(PendingSessionContext);
}
